import { render, staticRenderFns } from "./ranking-style-1.vue?vue&type=template&id=f115383a&"
import script from "./ranking-style-1.vue?vue&type=script&lang=js&"
export * from "./ranking-style-1.vue?vue&type=script&lang=js&"
import style0 from "./ranking-style-1.vue?vue&type=style&index=0&id=f115383a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports